define 'lib/product-reviews', ['jquery'], ($) ->
  class ProductReviews
    retrieveRating: (siteId, productKeys, successHandler) ->
      avisParameters = {
        'query': 'average',
        'products': productKeys,
        'idWebsite': siteId,
        'plateforme': 'fr'
      }

      $.post {
        data: JSON.stringify(avisParameters),
        url: 'https://awsapis3.netreviews.eu/product',
        contentType: 'application/json; charset=utf-8',
        success: (data) ->
          if not data
            successHandler(undefined)
            return

          averageCount = 0
          averageRating = 0

          for productId in productKeys
            productRatings = data[productId]

            if not productRatings
              continue

            for productRating in productRatings
              count = Number(productRating.count)
              averageCount += count
              averageRating += count * productRating.rate

          if averageCount == 0
            successHandler(undefined)
          else
            rating = (averageRating / averageCount).toFixed(2)
            successHandler(rating)
        error: ->
          successHandler(undefined)
      }

  return new ProductReviews